import { ItemResponse, UserResponse } from "baaanggg"
import { Link } from "react-router-dom"
import { resolveImageUrl } from "@helpers/image.helper";

type Prop = {
    item: ItemResponse
}

export function ItemCardV2({ item }: Prop) {
    return <Link to={`/item/${item.id}`}
        className="block rounded-2.5xl border border-jacarta-100 bg-white p-[1.1875rem] transition-shadow hover:shadow-lg dark:border-gray-900 dark:bg-gray-900">
        <figure className="relative">
            <img src={resolveImageUrl(item.image)} alt="item 4" className="w-full rounded-[0.625rem]"
                loading="lazy" />

            <div className="absolute left-3 -bottom-3">
                <div className="flex -space-x-2">
                    {
                        item.collection?.owner && <div>
                            <img src={resolveImageUrl(item.collection.owner.thumbUrl ?? "/src/img/logo/transparant_logo.png")} alt="creator"
                                className="h-6 w-6 rounded-full border-2 border-white hover:border-accent dark:border-gray-400 dark:hover:border-jacarta-500"
                                data-tippy-content="Creator: Sussygirl" />
                        </div>
                    }

                </div>
            </div>
        </figure>
        <div className="mt-7 flex items-center justify-between">
            <span className="font-display text-base text-jacarta-700 hover:text-accent dark:text-white">
                {item.name}
            </span>
        </div>
    </Link>
}